import {ValueObject} from '@s-ui/domain'

export class RelatedVehicleValueObject extends ValueObject {
  /**
   * @param {Object} params
   * @param {Number} params.doors
   * @param {String} params.imageUrl
   * @param {String} params.make
   * @param {String} params.makeId
   * @param {String} params.model
   * @param {String} params.modelId
   * @param {String} params.url
   * */
}
